import { instance as axios, setJwtToken } from "../../config/AxiosInstance";

// ------------get-category-list-------------
export const getCategoryListApi = async (data) => {
    const endPoint = `user/group/list` + "?" + new URLSearchParams(data).toString();
    return await axios.get(endPoint, setJwtToken());
};
// ------------get-category-list-------------
export const getOverviewCategoryListApi = async (data) => {
    const endPoint = `user/group/explored/list` + "?" + new URLSearchParams(data).toString();
    return await axios.get(endPoint, setJwtToken());
};
// ------------GET CMS DATA-------------
export const fetchSidebarListApi = async (data) => {
    const endPoint = `user/group/list` + "?" + new URLSearchParams(data).toString();
    return await axios.get(endPoint, setJwtToken());
};
// // -----------------Delete User Account------------------------
// export const deleteMessageApi = async (data) => {
//     const endPoint = "user/comment" + '?' + new URLSearchParams(data).toString()
//     return await axios.delete(endPoint, setJwtToken());
// };